export default __webpack_public_path__ + "media/images/footer-logo-f59c2c73a3af888770efb48acd950128.svg";